import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "Absenteeism";

export const postAbsenteeismReport = createAsyncThunk(
  `${namespace}/postAbsenteeism`,
  async (body, { rejectWithValue }) => {
    const api = "absenteeism";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postAbsenteeismExcel = createAsyncThunk(
  `${namespace}/postAbsenteeismExcel`,
  async (body, { rejectWithValue }) => {
    const api = "absenteeismexcel";
    const opt = {
      body:body ,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  absenteeismReport: {
    fromdate: new Date(Date.now() - 86400000).toISOString().slice(0, 10),
    todate: new Date().toISOString().slice(0,10),
  },
};

const absenteeismSlice = createSlice({
  name: "absenteeism",
  initialState,
  reducers: {
    updateAbsenteeismReport(state, action) {
      return { ...state, absenteeismReport: action.payload };
    },
    resetAbsenteeismReport(state, action){
      return{...state, absenteeismReport: initialState.absenteeismReport};
    },
  },
  extraReducers: {
    [postAbsenteeismReport.pending]: (state, action) => {
      state.loading = true;
    },
    [postAbsenteeismReport.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postAbsenteeismReport.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [postAbsenteeismExcel.pending]: (state, action) => {
      state.loading = true;
    },
    [postAbsenteeismExcel.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postAbsenteeismExcel.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
  },
});

export const { updateAbsenteeismReport, resetAbsenteeismReport } = absenteeismSlice.actions;
export default absenteeismSlice.reducer;
